module.exports = __webpack_public_path__ + "img/15.ac118a0b.jpg";